export default __webpack_public_path__ + "static/media/discord.e4436feb.png";